const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('');

export const html = function(options)
{
    const product = options.fulltext || options.snapshot ? 'rft' : 'ram';
    const searchString = options.fulltext ? 'full-text journals' : 'journals';
    const searchStringCaps = options.fulltext ? 'Full-Text Journals' : 'Journals';
    const alphabetHeader = options.fulltext ? 'Browse Full-Text Journals' : 'Browse Core and Secondary Titles';

    let base = '';

    if (!options.fulltext && !options.abstracts)
    {
        base += `<h2>Music Journals</h2>
        <p>Download a list of music journals included in <em>${options.title}</em>.</p>
        <div class="wp-block-rilm-org-rilm-readmore rilm-readmore">
            <span class="rilm-readmore-icon fa fa-chevron-circle-right"></span>
            <a href="/resources.php?product=${product}&amp;type=music" target="blank">HTML</a>
        </div>` +

        (options.musicExcelLink ? `
        <div class="wp-block-rilm-org-rilm-readmore rilm-readmore">
            <span class="rilm-readmore-icon fa fa-chevron-circle-right"></span>
            <a href="${options.musicExcelLink}" target="blank">Excel</a>
        </div>` : '') +


        `<h2>Non-Music Journals</h2>
        <p>Download a list of non-music journals included in <em>${options.title}</em>.</p>
        <div class="wp-block-rilm-org-rilm-readmore rilm-readmore">
            <span class="rilm-readmore-icon fa fa-chevron-circle-right"></span>
            <a href="/resources.php?product=${product}&amp;type=nonmusic" target="blank">HTML</a>
        </div>` +


        (options.nonMusicExcelLink ? `
        <div class="wp-block-rilm-org-rilm-readmore rilm-readmore">
            <span class="rilm-readmore-icon fa fa-chevron-circle-right"></span>
            <a href="${options.nonMusicExcelLink}" target="blank">Excel</a>
        </div>` : '') +

        `<h2>Other Resources</h2>
        <p>Download a list of other resources included in <em>${options.title}</em>.</p>
        <p>
          <form id="form" action="/resources.php" method="GET" onsubmit="return formCheck();" target="_blank">
            <span>Enter a year range:</span>
            <input type="hidden" name="product" value="${product}"/>
            <input type="hidden" name="type" value="other"/>
            <input class="year-range" type="text" placeholder="Start" name="from"/>
            <input class="year-range" type="text" placeholder="End" name="to"/>
            <input type="submit" value="HTML"/>
          </form>
        </p>

        <div id="form-debug" class="form-debug"></div>`;
    }

    if (!options.snapshot)
    {
    base += `<h2>${alphabetHeader}</h2>
        <div class="journal-letters">
            ${letters.map(l => `<span class="journal-priority-restricted journal-search-execute journal-letter" data-value="${l}">${l}</span>`).join('')}
        </div>

        ${options.fulltext ? '<div class="journal-search-concise-wrapper"><button class="journal-search-concise">Download concise list</button></div>' : ''}

        <h2>Search ${searchStringCaps}</h2>

        <p class="journalsearch">
          <div class="journalsearch-box">
            <div class="journalsearch-by">
              Search by:
              <select id="journalsearch-type">
                <option value="name">Title</option>
                <option value="pubName">Publisher</option>
                <option value="CC">Country</option>
                <option value="language">Language</option>
                <option value="priority">Priority</option>
                <option value="ISSN">ISSN</option>
                <option value="EISSN">EISSN</option>
                <option value="CODEN">CODEN</option>
              </select>
            </div>
            <div class="journalsearch-controls">
              <input class="journalsearch-input" data-target="name" tabindex="1" type="input"
                placeholder="Search all ${searchString} by title">
              <input class="journalsearch-input hidden" data-target="pubName" tabindex="1" type="input"
                placeholder="Search all ${searchString} by publisher name">
              <input class="journalsearch-input hidden" data-target="ISSN" tabindex="1" type="input"
                placeholder="Search all ${searchString} by ISSN">
              <input class="journalsearch-input hidden" data-target="EISSN" tabindex="1" type="input"
                placeholder="Search all ${searchString} by EISSN">
              <input class="journalsearch-input hidden" data-target="CODEN" tabindex="1" type="input"
                placeholder="Search all ${searchString} by CODEN">

              <select class="journalsearch-input hidden" data-target="CC">
                <option>Loading publication countries...</option>
              </select>
              <select class="journalsearch-input hidden" data-target="language">
                <option>Loading publication languages...</option>
              </select>
              <select class="journalsearch-input hidden" data-target="priority">
                <option>Loading publication priorities...</option>
              </select>

              <input type="button" value="Search" class="journal-search-execute journal-from-type">
              <input type="button" class="journal-search-execute journal-loadall" value="Show all ${searchString}"/>
            </div>
          </div>
          <div class="journalsearch-checkboxes">
            <div class="show-only">
              <input type="checkbox" class="journalsearch-bool" data-target="ISSN"/>
              Show only ${searchString} with ISSNs.
            </div>
            <div class="show-only">
              <input type="checkbox" class="journalsearch-bool" data-target="EISSN"/>
              Show only ${searchString} with EISSNs.
            </div>
            <div class="show-only">
              <input type="checkbox" class="journalsearch-bool" data-target="CODEN"/>
              Show only ${searchString} with CODENs.
            </div>
          </div>
        </p>
        <div id="accordion">
          <div id="resultsDiag"></div>
          <ul id="resultsTable"></ul>
        </div>`;
    }

    return base;
}
